export interface MarkdownHistoryKeyboardInput {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
}

export type MarkdownHistoryOffset = -1 | 1;

export const getMarkdownHistoryKeyboardOffset = ({
  key,
  ctrlKey,
  metaKey,
  shiftKey,
}: MarkdownHistoryKeyboardInput): MarkdownHistoryOffset | undefined => {
  if (!ctrlKey && !metaKey) {
    return undefined;
  }

  const normalisedKey = key.toLowerCase();
  if (normalisedKey === 'z') {
    return shiftKey ? 1 : -1;
  }

  if (normalisedKey === 'y' && !shiftKey) {
    return 1;
  }

  return undefined;
};
